module.exports = __webpack_public_path__ + "static/media/villalonga.d4f8b437.jpg";